module.exports = __webpack_public_path__ + "static/img/about-responsibility.002353c1.png";